export default __webpack_public_path__ + "static/media/woman_with_phone_black.1e578e16.png";